import { Directive, ElementRef, Input, OnInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[dynamicFontSize]',
})
export class DynamicFontSizeDirective implements OnInit, OnDestroy {
  @Input() base: number = 16; // Default font size in pixels
  @Input() scale: number = 0.02; // Default scale factor

  private resizeObserver: ResizeObserver;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.initializeResizeObserver();
  }

  ngOnDestroy() {
    this.resizeObserver.disconnect();
  }

  private initializeResizeObserver() {
    this.resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        this.adjustFontSize(entry.contentRect.width);
      }
    });
    this.resizeObserver.observe(this.el.nativeElement);
  }

  private adjustFontSize(elementWidth: number) {
    const newSize = Math.round((elementWidth / 100) * this.scale);
    this.el.nativeElement.style.fontSize = `${newSize}px`;
  }
}

interface ResizeObserverEntry {
  readonly target: Element;
  readonly contentRect: DOMRectReadOnly;
}

type ResizeObserverCallback = (
  entries: ResizeObserverEntry[],
  observer: ResizeObserver,
) => void;

interface ResizeObserver {
  observe(target: Element): void;
  unobserve(target: Element): void;
  disconnect(): void;
}

declare var ResizeObserver: {
  prototype: ResizeObserver;
  new (callback: ResizeObserverCallback): ResizeObserver;
};
